import {
    SURVEY_EDITOR_LIKERT_DIMENSION_ORDESCRIPTION_CHANGE
} from "../../../../../constants";


export const onChangeLikertDecriptionAndDimension = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: SURVEY_EDITOR_LIKERT_DIMENSION_ORDESCRIPTION_CHANGE, payload });
    }
};